import React, { useState, useEffect } from "react";
import { SimpleForm } from "simple-ui-components";

import { FilterByStyled } from "../../theme";
import { getTranslation } from "../languageProvider";

export const FilterAccount = ({ Filter }) => {
  const { InputGroup } = SimpleForm;

  const [nameEmail, setNameEmail] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [accountType, setAccountType] = useState(0);

  const ACCOUNT_TYPES = [
    { label: getTranslation("0128"), value: "0" },
    { label: getTranslation("0088"), value: "20" },
    { label: getTranslation("0072"), value: "30" },
  ];

  const nameChangeHandler = (event) => {
    setNameEmail(event.target.value);
    setIsFilter(true);
  };

  useEffect(() => {
    if (isFilter) {
      let toSend = {
        accountType: accountType,
        nameEmail: nameEmail,
      };
      Filter(toSend);
      setIsFilter(false);
    }
  }, [isFilter, nameEmail, Filter, accountType]);

  const changeAccountTypeChangeHandler = (e) => {
    setAccountType(e.target.value);
    setIsFilter(true);
  };

  return (
    <FilterByStyled className="outline md">
      <InputGroup
        type="input"
        name="filterAccount"
        placeholder={`${getTranslation("0126")}/${getTranslation("0002")}`}
        inputElement={{
          name: "filterAccount",
          onChange: nameChangeHandler,
          type: "text",
          defaultValue: nameEmail,
          className: nameEmail ? "focused" : "",
          translate: "0126",
        }}
      />
      <InputGroup
        type="select"
        name="accountType"
        placeholder={getTranslation("0127")}
        inputElement={{
          defaultValue: accountType,
          options: ACCOUNT_TYPES,
          onChange: changeAccountTypeChangeHandler,
        }}
      />
    </FilterByStyled>
  );
};
